import { render, staticRenderFns } from "./PopupRiskInfo_3x3_3.vue?vue&type=template&id=2b44d5b4&scoped=true"
import script from "./PopupRiskInfo_3x3_3.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfo_3x3_3.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfo_3x3_3.vue?vue&type=style&index=0&id=2b44d5b4&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfo_3x3_3.vue?vue&type=style&index=1&id=2b44d5b4&prod&lang=css"
import style2 from "./PopupRiskInfo_3x3_3.vue?vue&type=style&index=2&id=2b44d5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b44d5b4",
  null
  
)

export default component.exports